define('NVT.AnnualApplicationFormE.ReworkUploadDocuments.View'
, [
      'Backbone'

    , 'nvt_mulitple_upload_rework_document.tpl'

    , 'NVT.AnnualApplicationFormE.AnnualApplicationFormE.SS2Model'

    , 'Backbone.FormView'

    , 'GlobalViews.Message.View'

    , 'underscore'

    , 'jQuery'

    , 'Utils'    
  ]
, function
  (
        
    Backbone

    , nvt_mulitple_upload_rework_document_tpl

    , AnnualApplicationFormESS2Model

    , BackboneFormView

    , MessageView

    , _

    , jQuery

    , Utils    

  )
{
  'use strict';

    return Backbone.View.extend({
           
        template: nvt_mulitple_upload_rework_document_tpl

    ,   title: Utils.translate('Supporting Document')

    ,   initialize: function(options)
        {
            this.options = options;
            this.application = options.application;
            this.page_header = "Supporting Document";	
            this.modalClass ='modal-md modal_md_custom';  
            var self = this;
            self.globalmultipleuploadfilelist = [];
            self.remarkss = '';
            BackboneFormView.add(this);
        }

    ,   events: 
        {
            'click button[data-action="docUploadings"]': 'docUploadings',
            
            'click button[data-action="dynemic-multiple-upload-Remove"]': 'dynemicMultipleUploadRemove',

            'submit form': 'saveTheForm'
        }   
        

    ,   dynemicMultipleUploadRemove: function (e) {
            e.preventDefault();
            var self = this;
            var id = jQuery(e.target).val();
            if (id) {
                var selectedMUFRemove = self.globalmultipleuploadfilelist.filter(function (muf) { if (muf.id != id) { return muf; } });
                self.globalmultipleuploadfilelist = selectedMUFRemove;
                self.render();
            }
        }


    ,   docUploadings: function(e)
        {
            e.preventDefault();
            e.stopImmediatePropagation();

            var self = this;
            var getfileDetails = $('[name="hd_mulitplefileup"]').val();
            self.remarkss = $('[name="remark"]').val();

            var maxFilesAllowed = 5;
            var currentFileCount = self.globalmultipleuploadfilelist.length;

            if(!getfileDetails)
            {
                self.showMessage('File is required', 'error','mulitplefileup');
                return false;
            }
            else if(currentFileCount >= maxFilesAllowed){
                self.showMessage('You can only upload a maximum of 5 files.', 'error','mulitplefileup');
                return false;
            }
            else
            {
                var splitDataArr = getfileDetails.split(",");
                for (let [i, muf] of self.globalmultipleuploadfilelist.entries()) {
                    if (muf.global_fileName === splitDataArr[2]) {
                        self.globalmultipleuploadfilelist.splice(i, 1);
                    }
                }

                var getCurrentFileDetails = {
                    'id':new Date().getTime(),
                    'global_fileName':splitDataArr[2],
                    'global_filetype':splitDataArr[3],
                    'global_filesize':  (splitDataArr[4] / (1024*1024)).toFixed(2) + ' MB',
                    'global_filedetails':getfileDetails,
                    'getfileId':self.options.getmemid,
                    'folderlocfile' : SC.CONFIGURATION.AnnualApplicationFormE.config,
                }
              
                self.globalmultipleuploadfilelist.push(getCurrentFileDetails);
                self.render();
            }                             
        }

    ,   saveTheForm: function(e, model, props)
        {
            e.preventDefault();
            e.stopImmediatePropagation();

            var self = this,
                $target = jQuery(e.target),
                getfielddata = $target.serializeObject();
                
            // if(!getfielddata.remark)
            // {
            //     self.showMessage('Field value is required', 'error','remark');
            //     return false;
            // }
            if(self.globalmultipleuploadfilelist.length == 0)
            {
                self.showMessage('Field is required', 'error','mulitplefileup');
                return false;
            }
            else
            {
                getfielddata['mfu'] = JSON.stringify(self.globalmultipleuploadfilelist);
                this.model.set(getfielddata);
                e.data = getfielddata;
                var promise = BackboneFormView.saveForm.call(this, e, this.model,getfielddata)
                this.$containerModal.addClass('fade').modal('show').data('bs.modal', null);

                    return promise && promise.then
                    (
                        function (responce) {
                            if (responce.successMessage) {
                                self.showMessage(responce.successMessage, 'success');
                            }
                            else {
                                self.showMessage(responce.errorMessage, 'error')
                            }

                            return false;
                        }
                    );
            }                             
        }

    ,   showMessage: function(message, type, field)
        {
            jQuery('.global-views-message-error').remove(); 
            jQuery('.global-views-message-success').remove(); 
            var messageView = new MessageView
            ({
                    message: message
                ,   type: type
                ,   closable: type =='error' ? true : false
            });
            if (typeof field !== 'undefined')
            {
                this.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
            }
            else if (type =='error'){
                this.application.getLayout().$('form').append(messageView.render().$el);
            }
            else
            {
                this.application.getLayout().$('form').empty().html(messageView.render().$el);       
                setTimeout(function() {
                    jQuery("[data-dismiss=modal]").trigger({ type: "click" });                    
                }, 1000);
            }
        }    

    ,   getContext: function() {

            var self = this;

            return {
                title : this.title,

                remarkss :self.remarkss || '',

                globalmultipleuploadfilelist : self.globalmultipleuploadfilelist
            }
        }        

    });

});
